__turbopack_context__.v({
  "item": "layout-module__bwN0ea__item",
  "row": "layout-module__bwN0ea__row",
});
